import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ERectangle extends OBase {
  update () {
    let pTree = this.getVector3Input('p', false);
    let xTree = this.getIntervalObjectInput('x');
    let yTree = this.getIntervalObjectInput('y');

    let output = this.getGenericObjectOutput('rectangle');

    let dataTrees = [];
    let outDataTrees = [];
    dataTrees.push(pTree, xTree, yTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let p = outDataTrees[0].branches[i][j];
        let x = outDataTrees[1].branches[i][j];
        let y = outDataTrees[2].branches[i][j];

        let path = [];

        path.push(new ClipperLib.DoublePoint(p.x + x.min, p.y + y.min));
        path.push(new ClipperLib.DoublePoint(p.x + x.max, p.y + y.min));
        path.push(new ClipperLib.DoublePoint(p.x + x.max, p.y + y.max));
        path.push(new ClipperLib.DoublePoint(p.x + x.min, p.y + y.max));

        outTree.add([path], outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ERectangle.js